import React from 'react'
import PropTypes from 'prop-types'

import SuccessMessage from '../Landing/Modules/SuccessMessage.jsx'
import LiteratureDocs from './LiteratureDocs.jsx'
import SubscriptonDocs from './SubscriptionDocs.jsx'

function ModifySubscriptionModal({
  literature,
  subscriptions,
  handleSubscriptionLiteratureClick,
  handleSubscriptionClick,
  handleModifyClick,
  name,
  modifySuccess,
  subscribed,
  modified,
}) {
  const compareFunction = (a, b) => {
    const literatureOrder = [
      'Fact Sheet',
      'Monthly Fund Commentary',
      'Commentary',
      'Product Updates',
      'Capital Gains Estimates and Distributions',
    ]

    if (literatureOrder.indexOf(b['name']) === -1) return -1
    if (literatureOrder.indexOf(a['name']) === -1) return 1

    return (
      literatureOrder.indexOf(a['name']) - literatureOrder.indexOf(b['name'])
    )
  }

  const _literature = literature.sort(compareFunction)

  return (
    <>
      {modifySuccess && (
        <SuccessMessage subscribed={subscribed} modified={modified} />
      )}

      <div
        className="Grid u-marginTop6gu js-modify-modal"
        data-analytics="cesc-modal-modify-preferences"
      >
        <div className="u-sizeFull">
          <h4 className="u-marginBottom3gu">{name}</h4>
          <LiteratureDocs
            literature={_literature}
            handleSubscriptionClick={handleSubscriptionLiteratureClick}
          />
          <SubscriptonDocs
            subscriptions={subscriptions}
            handleSubscriptionClick={handleSubscriptionClick}
          />
        </div>

        <hr
          className="Rule Rule--thin u-bgColorNeutral u-marginVert5gu"
          role="presentation"
        ></hr>

        <div className="u-flex u-sm-flexCol">
          <button
            className="Button Button--primary u-paddingHoriz10gu u-paddingVert2gu u-sm-marginBottom3gu"
            data-analytics="cesc-modify-preferences"
            onClick={handleModifyClick}
          >
            Modify Preferences
          </button>
          <a
            href="/subscribe"
            className="Link u-lg-flexExpandLeft u-md-flexExpandLeft u-flexAlignSelfCenter"
            target="_blank"
            data-analytics="cesc-manage-all-subscriptions"
          >
            Manage All Subscriptions
          </a>
        </div>
      </div>
    </>
  )
}

ModifySubscriptionModal.propTypes = {
  literature: PropTypes.array,
  subscriptions: PropTypes.array,
  handleSubscriptionLiteratureClick: PropTypes.func,
  handleSubscriptionClick: PropTypes.func,
  handleModifyClick: PropTypes.func,
  name: PropTypes.string,
  modifySuccess: PropTypes.bool,
  subscribed: PropTypes.bool,
  modified: PropTypes.bool,
}

export default ModifySubscriptionModal
